// extracted by mini-css-extract-plugin
module.exports = {"container":"comments_container__SnRxA","containerTitle":"comments_containerTitle__GK5TR","avatar":"comments_avatar__To7kH"};